export interface IQuery { }

export class DatasetChangeLogQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Datasets.Queries.DatasetChangeLogQueryV1, TCh.Domain.Integrations'

	DatasetId: string

	constructor (datasetId: string)
	{
		this.DatasetId = datasetId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Datasets.Queries.DatasetChangeLogQueryV1, TCh.Domain.Integrations'
	}

}

export class DatasetDetailsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Datasets.Queries.DatasetDetailsQueryV1, TCh.Domain.Integrations'

	DatasetId: string

	constructor (datasetId: string)
	{
		this.DatasetId = datasetId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Datasets.Queries.DatasetDetailsQueryV1, TCh.Domain.Integrations'
	}

}

export class DatasetPropertyNamesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Datasets.Queries.DatasetPropertyNamesQueryV1, TCh.Domain.Integrations'

	DatasetId: string

	constructor (datasetId: string)
	{
		this.DatasetId = datasetId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Datasets.Queries.DatasetPropertyNamesQueryV1, TCh.Domain.Integrations'
	}

}

export class DatasetsOfOrganizationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Datasets.Queries.DatasetsOfOrganizationQueryV1, TCh.Domain.Integrations'

	OrganizationUnitId: string

	constructor (organizationUnitId: string)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Datasets.Queries.DatasetsOfOrganizationQueryV1, TCh.Domain.Integrations'
	}

}

